export var getStudioToken = function getStudioToken() {
  return {
    focusedOutlineColor: '#4c9ffe',
    colorTypeBoolean: '#D8C152',
    colorTypeNumber: '#5295C4',
    colorTypeString: '#149E6D',
    colorTypeBoolArray: '#D8C152',
    colorTypeNumberArray: '#239BEF',
    colorTypeStringArray: '#62AE8D'
  };
};
export var themeToken = getStudioToken({});